import { CourseType } from '../enums/course-type.enum';

export const COURSE_TYPE_LABELS: Record<CourseType, string> = {
  [CourseType.TRAINING]: 'Treinamento',
  [CourseType.COURSE]: 'Curso'
};
